import React from "react";
import TZMMainContent from "../../../components/main/TZMMainContent";
import TZMTabView from "../../../components/panel/TZMTabView";
import TZMTabPanel from "../../../components/panel/TZMTabPanel";
import TZMPanel from "../../../components/panel/TZMPanel";
import TZMButton from "../../../components/common/TZMButton";
import TZMColumn from "../../../components/table/TZMColumn";
import TZMPanelFooter from "../../../components/panel/TZMPanelFooter";
import { ModalRealm } from "../../../components/modal/ModalRealm";
import TZMTable from "../../../components/table/TZMTable";
import TZMAutoComplete from "../../../components/common/TZMAutoComplete";
import TZMConfirm from "../../../components/dialog/TZMConfirm";
import { TipoMovimentoService } from "../../servicos/TipoMovimentoService";
import { ConfiguracaoService } from "../../servicos/ConfiguracaoService";
import { CFOPService } from "../../servicos/CFOPService";
import "./styles.css";

const title = "Configurações";
const empresaNome = process.env.REACT_APP_EMPRESA_NOME;

export default class Configuracao extends React.Component {

	constructor() {
		super();
		this.configuracaoService = new ConfiguracaoService();
		this.tipoMovimentoService = new TipoMovimentoService();
		this.cfopService = new CFOPService();
		this.state = {
			configuracao: {
				tipoMovimento: {
					descricaoAmigavel: '',
					pk: {}
				},
				cfop: {
					descricaoAmigavel: '',
					pk: {}
				},
				tiposMovimento: [],
				codigosTributario: [],				
				cfops: []
			},
			codigoTributarioInput: ""
		};
		this.completar = this.completar.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.salvar = this.salvar.bind(this);		
		this.handleChangeParams = this.handleChangeParams.bind(this);
		this.listarTiposMovimento = this.listarTiposMovimento.bind(this);
		this.addTipoMovimento = this.addTipoMovimento.bind(this);
		this.delTipoMovimento = this.delTipoMovimento.bind(this);
		this.renderAcaoTipoMovimento = this.renderAcaoTipoMovimento.bind(this);
		this.handleCodigoTributarioInputChange = this.handleCodigoTributarioInputChange.bind(this);
		this.addCodigoTributario = this.addCodigoTributario.bind(this);
		this.removeCodigoTributario = this.removeCodigoTributario.bind(this);
		this.renderAcaoCodigoTributario = this.renderAcaoCodigoTributario.bind(this);
		this.addCfop = this.addCfop.bind(this);
		this.delCfop = this.delCfop.bind(this);
		this.listarCfops = this.listarCfops.bind(this);
		this.renderAcaoCfop = this.renderAcaoCfop.bind(this);
	}

	completar() {
		this.configuracaoService.completar().then(configuracao => {
			if (!Array.isArray(configuracao.tiposMovimento)) {
				configuracao.tiposMovimento = [];
			}
			if (Array.isArray(configuracao.codigosTributario)) {
				configuracao.codigosTributario = configuracao.codigosTributario.map(codigo => ({ codigo }));
			}
			this.setState({ configuracao });
		});
	}

	componentDidMount() {
		this.completar();
	}

	renderAcaoTipoMovimento(tipoMovimento) {
		return (
			<div>
				<span
					title="Remover Tipo Movimento"
					className="fa fa-trash-alt ui-tzm-icon"
					onClick={() => this.delTipoMovimento(tipoMovimento)}
				/>
			</div>
		);
	}

	get columnsTipoMovimento() {
		return [
			<TZMColumn key="codigo" header="Código" field="pk.tipoMovimentoId" style={{ width: "8em", textAlign: "center" }} />,
			<TZMColumn key="descricao" header="Descrição" field="descricao" />,
			<TZMColumn key="acao" header="Ações" style={{ width: "4em", textAlign: "center" }} body={this.renderAcaoTipoMovimento} />
		];
	}

	handleClear(event) {
		this.setState(prevState => {
			const configuracao = { ...prevState.configuracao };
			configuracao[event.name] = null;
			return { configuracao };
		});
	}

	handleUnselect = (event) => {
			this.setState(prevState => {
			const configuracao = { ...prevState.configuracao };
			if (!configuracao[event.name]) {
				configuracao[event.name] = [];
			}
			configuracao[event.name] = configuracao[event.name].filter((e) => e.id !== event.value.id);
			return { configuracao };
		});
	}

	handleSelect(event) {
		this.setState(prevState => {
			const configuracao = { ...prevState.configuracao };
			configuracao[event.name] = event.value;
			return { configuracao };
		});
	}

	salvar() {
		const { configuracao } = this.state;
		const payload = {
			...configuracao,
			codigosTributario: (configuracao.codigosTributario || []).map(ct =>
				typeof ct === 'object' && ct !== null ? ct.codigo : ct
			)
		};
		this.configuracaoService.salvar(payload).then(() => {
			this.completar();
		});
	}

	handleChangeParams(event) {
		this.setState(prevState => {
			const params = { ...(prevState.params || {}) };
			params[event.name] = event.value;
			return { params };
		});
	}

	async listarTiposMovimento(event) {
		let params = {};
		let notIn = this.state.configuracao?.tiposMovimento || [];
		params.tipomovimento = event.query;
		params.sort = "pk.tipoMovimentoId";
		params.notIn = notIn.map(c => c.pk.tipoMovimentoId).join(",");
		await this.tipoMovimentoService.listarSimples(params).then(tiposMovimento => this.setState({ tiposMovimento }));
	}

	addTipoMovimento(event) {
		this.setState(prevState => {
			const configuracao = { ...prevState.configuracao };
			if (!Array.isArray(configuracao.tiposMovimento)) {
				configuracao.tiposMovimento = [];
			}
			configuracao.tiposMovimento = [event.value, ...configuracao.tiposMovimento];
			configuracao.tipoMovimento = null;
			return { configuracao };
		});
	}

	delTipoMovimento(tipoMovimento) {
		ModalRealm.showDialog(
			<TZMConfirm
				onYes={() => {
					this.setState(prevState => {
						const configuracao = { ...prevState.configuracao };
						configuracao.tiposMovimento = configuracao.tiposMovimento.filter(c => c !== tipoMovimento);
						return { configuracao };
					});
				}}
				question="Tem certeza de que deseja remover este tipo de movimento?"
			/>
		);
	}

	tipoMovimentoTemplate(tipoMovimento) {
		return <div>{tipoMovimento.pk.tipoMovimentoId} - {tipoMovimento.descricao}</div>;
	}

	handleCodigoTributarioInputChange(event) {
		this.setState({ codigoTributarioInput: event.target.value });
	}

	get columnsCodigoTributario() {
		return [
			<TZMColumn key="codigo" header="Código Tributário" field="codigo" style={{ width: "12em", textAlign: "center" }} />,
			<TZMColumn
				key="acao"
				header="Ações"
				style={{ width: "4em", textAlign: "center" }}
				body={this.renderAcaoCodigoTributario}
			/>
		];
	}

	renderAcaoCodigoTributario = (rowData) => (
		<div>
			<span
				title="Remover Código Tributário"
				className="fa fa-trash-alt ui-tzm-icon"
				onClick={() => this.removeCodigoTributario(rowData.codigo)}
			/>
		</div>
	);

	addCodigoTributario() {
		const valor = this.state.codigoTributarioInput.trim();
		if (valor && !isNaN(valor)) {
			this.setState(prevState => {
				const codigosTributario = prevState.configuracao.codigosTributario || [];
				if (codigosTributario.some(ct => ct.codigo === Number(valor))) return { codigoTributarioInput: "" };
				return {
					configuracao: {
						...prevState.configuracao,
						codigosTributario: [...codigosTributario, { codigo: Number(valor) }]
					},
					codigoTributarioInput: ""
				};
			});
		}
	}

	removeCodigoTributario(codigo) {
		this.setState(prevState => ({
			configuracao: {
				...prevState.configuracao,
				codigosTributario: prevState.configuracao.codigosTributario.filter(ct => ct.codigo !== codigo)
			}
		}));
	}

	get columnsCfop() {
		return [
			<TZMColumn key="codigo" header="CFOP" field="pk.cfopId" style={{ width: "8em", textAlign: "center" }} />,
			<TZMColumn key="descricao" header="Descrição" field="descricao" />,
			<TZMColumn key="acao" header="Ações" style={{ width: "4em", textAlign: "center" }} body={this.renderAcaoCfop} />
		];
	}

	renderAcaoCfop(rowData) {
		return (
			<div>
				<span
					title="Remover CFOP"
					className="fa fa-trash-alt ui-tzm-icon"
					onClick={() => this.delCfop(rowData)}
				/>
			</div>
		);
	}

	addCfop(event) {
		this.setState(prevState => {
			const configuracao = { ...prevState.configuracao };
			if (!Array.isArray(configuracao.cfops)) {
				configuracao.cfops = [];
			}
			configuracao.cfops = [event.value, ...configuracao.cfops];
			configuracao.cfop = null;
			return { configuracao };
		});
	}

	delCfop(cfop) {
		ModalRealm.showDialog(
			<TZMConfirm
				onYes={() => {
					this.setState(prevState => {
						const configuracao = { ...prevState.configuracao };
						configuracao.cfops = configuracao.cfops.filter(c => c !== cfop);
						return { configuracao };
					});
				}}
				question="Tem certeza de que deseja remover este cfop?"
			/>
		);
	}

	async listarCfops(event) {
		let params = {};
		let notIn = this.state.configuracao?.cfops || [];
		params.cfops = event.query;
		params.sort = "pk.cfopId";
		params.notIn = notIn.map(c => c.pk.cfopId).join(",");
		await this.cfopService.listarSimples(params).then(cfops => this.setState({ cfops }));
	}

	render() {
		return (
			<TZMMainContent>
				<TZMTabView>
					<TZMTabPanel header="Configuração Fiscal do Pedido">
						
							<div className="ui-g">
								<div className="ui-g-4">
									<TZMPanel header="Tipos de Movimento">
										<span className="ui-fluid">
											<TZMAutoComplete
												minLength={2}
												onClear={this.handleClear}
												onSelect={this.addTipoMovimento}
												onUnselect={this.handleUnselect}
												itemTemplate={this.tipoMovimentoTemplate}
												onChange={this.handleSelect}
												suggestions={this.state.tiposMovimento}
												placeholder="Código ou descrição"
												field="descricaoAmigavel"
												name="tipoMovimento"
												completeMethod={this.listarTiposMovimento}
												label="Tipo de Movimento"
												value={this.state.configuracao.tipoMovimento}
												dropdown
											/>
										</span>	
										<TZMTable
											value={this.state.configuracao.tiposMovimento}
											emptyMessage="Nenhum tipo de movimento adicionado"
										>
											{this.columnsTipoMovimento}
										</TZMTable>
									</TZMPanel>
									
								</div>
								<div className="ui-g-4">
									<TZMPanel header="CFOP">
										<span className="ui-fluid">
											<TZMAutoComplete
												minLength={2}
												onClear={this.handleClear}
												onSelect={this.addCfop}
												onUnselect={this.handleUnselect}
												itemTemplate={cfop => <div>{cfop.pk.cfopId} - {cfop.descricao}</div>}
												onChange={this.handleSelect}
												suggestions={this.state.cfops}
												placeholder="Código ou descrição"
												field="descricaoAmigavel"
												name="cfop"
												completeMethod={this.listarCfops}
												label="CFOP"
												value={this.state.configuracao.cfop}
												dropdown
											/>
										</span>	
										<TZMTable
											value={this.state.configuracao.cfops}
											emptyMessage="Nenhum CFOP adicionado"
										>
											{this.columnsCfop}
										</TZMTable>
									</TZMPanel>

								</div>
								<div className="ui-g-4">
									<TZMPanel header="Códigos Tributarios">
										<div className="cods-tributarios-panel">
											<div className="cods-tributarios-form-row">
												<input
													className="cods-tributarios-input"
													type="number"
													value={this.state.codigoTributarioInput}
													onChange={this.handleCodigoTributarioInputChange}
													placeholder="Digite o código tributário"
												/>
												<TZMButton
													icon="fa fa-plus"
													onClick={this.addCodigoTributario}
													success
													type="button"
													className="cods-tributarios-btn"
												/>
											</div>
											<div className="cods-tributarios-table-wrapper">
												<TZMTable
													value={this.state.configuracao.codigosTributario}
													emptyMessage="Nenhum código tributário adicionado"
												>
													{this.columnsCodigoTributario}
												</TZMTable>
											</div>
										</div>
									</TZMPanel>
								</div>
							</div>
							<TZMPanelFooter>
								<TZMButton success label="Salvar" icon="fas fa-save" onClick={this.salvar} />
							</TZMPanelFooter>
						
					</TZMTabPanel>
				</TZMTabView>
				<span className="ui-tzm-dashboard-title">{empresaNome} - {title}</span>
				<ModalRealm />
			</TZMMainContent>
		);
	}
}
